// add polyfills here
import * as Sentry from '@sentry/react';

import {Settings} from 'luxon';

import config from './config';

import React from 'react';
import {createRoot} from 'react-dom/client';

import './public/serviceWorker';

import Root from './components/roots';

import './styles/globals.scss';


Settings.defaultZone = 'UTC';


const {sentry} = config;
Sentry.init({
    ...sentry
});


const appContainer = document.getElementById('appContainer');
const appRoot = createRoot(appContainer);
appRoot.render(<Root/>);
